import { IPreloadedState } from 'shared/types/redux';

export const selectLocation = (state: IPreloadedState) => state.location;
